import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filter", "list"]
  static values = {
    channelUrl: String
  }

  connect() {
    // Load saved filter preference from localStorage
    const savedFilter = localStorage.getItem("postStatusFilter") || "open"
    // Apply the filter and fetch posts on initial load
    this.applyFilter(savedFilter, true)
  }

  select(event) {
    event.preventDefault()
    const status = event.currentTarget.dataset.status
    this.applyFilter(status, true)
  }

  applyFilter(status, shouldFetch = true) {
    // Update active state on filter pills
    this.filterTargets.forEach(filter => {
      const filterStatus = filter.dataset.status
      if (filterStatus === status) {
        filter.classList.remove("text-muted-foreground", "hover:text-foreground")
        filter.classList.add("bg-primary/10", "text-primary", "font-medium")
      } else {
        filter.classList.remove("bg-primary/10", "text-primary", "font-medium")
        filter.classList.add("text-muted-foreground", "hover:text-foreground")
      }
    })

    // Save to localStorage
    localStorage.setItem("postStatusFilter", status)

    // Fetch filtered posts if needed
    if (shouldFetch) {
      this.fetchPosts(status)
    }
  }

  fetchPosts(status) {
    const url = new URL(this.channelUrlValue, window.location.origin)
    if (status !== "all") {
      url.searchParams.set("status", status)
    }

    fetch(url, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
    .then(response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html)
    })
  }
}
